// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__Q5Ppt","colMaxWidth":"Table_colMaxWidth__FzaSj"};